import React from 'react'
import { createRoot } from 'react-dom/client'
import { AppContainer } from './containers/AppContainer/AppContainer'
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { getOrGenerateDeviceID } from './graphql-client/storedState';

getOrGenerateDeviceID()

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.debug = () => {}
  // console.error = (...args: unknown[]) => {
  //   datadogRum.addError(args[0] instanceof Error ? args[0] : new Error(String(args[0])))
  // }
}

export { DataDogContextKeys } from './datadog'

if (process.env.NODE_ENV === 'production') {

  const isProductionHostname = window.location.hostname.startsWith('app.innohinaus')

  datadogRum.init({
      applicationId: '73099dff-4b12-40fe-8df6-ad5e522f84bd',
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
      site: 'datadoghq.eu',
      service:'innohinaus-app',
      env: isProductionHostname ? 'prod' : 'dev',
      version: process.env.REACT_APP_COMMIT_REF,
      sessionSampleRate: isProductionHostname ? 100 : 0,
      sessionReplaySampleRate: isProductionHostname ? 20 : 0,
      defaultPrivacyLevel: 'allow',
      storeContextsAcrossPages: true,
      trackViewsManually: true,
      plugins: [reactPlugin({ router: false })],
  });
}

const root = createRoot(document.getElementById('root')!)
root.render(<AppContainer />)
